import NiotaClassicApiService from '@/services/niotaClassicApiService';
import listMixin from '../listMixin';
import { mapState, mapGetters } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDatasourcesList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {},
  data: function () {
    return {
      tableOptions: {
        sortBy: ['source'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right'
        }, {
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.source'),
          value: 'source',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.type'),
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.status'),
          value: 'status',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.active'),
          value: 'active',
          align: 'center',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }, {
          sortable: false
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  methods: {
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      NiotaClassicApiService.dataSourcesFetch((this.searchItem || '').trim(), usedPage, usedItemsPerPage, sortItem, sortDirection).then(res => {
        this.list = res.data.datasources;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching datasources', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    deletePromise() {
      return NiotaClassicApiService.dataSourcesDelete(this.selectedItem.id);
    }
  }
};